import axios from 'axios';
import crypto from 'crypto';
import zlib from 'zlib';
import xml2js from 'xml2js';
import { decryptAndDeCompress, encryptAndCompress } from './util';
import { useQuery } from '@tanstack/react-query';
import { notSchCon } from './query-key';
require('dotenv').config();
const envs = require('./env.json');

const uri = `${envs['env_uri']['uri']}/api/users/fetch`;
const uriSer = `${envs['env_uri']['uri']}/api/users/`;

// Helper function to get token from secure config with graceful fallback
const getToken = () => {
    // Only get from global secure config - NO environment variable fallbacks
    if (typeof window !== 'undefined' && window.getSecureConfig) {
        try {
            const config = window.getSecureConfig();
            if (config && config.REACT_APP_TOKEN) {
                return config.REACT_APP_TOKEN;
            }
        } catch (err) {
            console.warn('Failed to get token from secure config:', err);
        }
    }

    // For persistent authentication scenarios, we still return null but with less aggressive warning
    console.debug('Secure config not yet available - API calls will be retried when config loads');
    return null;
};

// Helper function to get current config with better error handling for persistent auth
const getConfig = () => {
    const token = getToken();
    if (!token) {
        throw new Error(
            'No authentication token available. Please ensure you are logged in and configuration is loaded.'
        );
    }

    return {
        headers: {
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${token}`,
        },
    };
};

// Remove static assignments - use dynamic getConfig() instead
// const token = getToken();
// const config = getConfig();

// const config = {
//   headers: {
//     "Access-Control-Allow-Origin": "*",
//     "Content-Type": "application/json",
//   },
// };

const bodyParameters = {
    type: 'fetch',
    qry: 'qryv',
    firstVal: '2020-09-01',
    secondVal: '2020-09-30',
};

export const fetchTrend = async (query, limit) => {
    bodyParameters['qry'] = query;
    bodyParameters['firstVal'] = limit;

    // console.log("data", bodyParameters, "json is", limit);

    try {
        const { data } = await axios.post(uri, bodyParameters);
        // console.log("data is ", data["data"][0]);
        return data['data'][0];
    } catch (error) {
        console.log(error);
    }
};

export const fetchJsData = async (jsVal) => {
    try {
        const encReq = encryptAndCompress(jsVal, '');
        const { data } = await axios.post(uri, { encReq }, getConfig());
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const fetchQryData = async (jsVal, signal) => {
    try {
        const encReq = encryptAndCompress(jsVal, '');
        const { data } = await axios.post(uri, { encReq, signal }, getConfig());
        return data?.data ?? [];
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const useConAppQry = (jsVal, key) => {
    return useQuery({
        queryKey: notSchCon.notify_sch_con(key),
        queryFn: ({ signal }) => fetchQryData(jsVal, signal),
        staleTime: Infinity,
    });
};

export const authorizeData = async (jsVal) => {
    try {
        const { data } = await axios.post(uriSer + 'authsf', jsVal, getConfig());
        // console.log('hi', data['data']['resp']);
        const newData = data['data']['resp'] ? data['data']['resp'] : data['data'];
        const decData = decryptAndDeCompress(newData, jsVal.usr);
        const encData = JSON.parse(decData);

        // console.log('hi', encData);
        // console.log('dec', JSON.stringify(encData).includes(jsVal.usr));
        if (encData.access_token && JSON.stringify(encData).includes(jsVal.usr)) {
            const encReq = encryptAndCompress(
                {
                    type: 'fetch',
                    qry: 'fetUsrExists',
                    firstVal: jsVal.usr.split('@')[0],
                    secondVal: jsVal.usr,
                },
                ''
            );
            const usrExs = await axios.post(
                uriSer + '/fetch',
                {
                    encReq,
                },
                getConfig()
            );
            // console.log('da- ', usrExs['data']['data'][0][0]);
            encData.usr_exst = usrExs['data']['data'][0][0] ? usrExs['data']['data'][0][0] : '';
            // console.log("us- ", usrExs["data"]["data"][0].exst);
            // console.log(encData);
            return encData;
        } else {
            return encData;
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const authorizeGoogle = async (data) => {
    try {
        if (data['usr']) {
            const encReq = encryptAndCompress(
                {
                    type: 'fetch',
                    qry: 'fetUsrExists',
                    firstVal: data.usr.split('@')[0],
                    secondVal: data.usr,
                },
                ''
            );
            const usrExs = await axios.post(
                uriSer + '/fetch',
                {
                    encReq,
                },
                getConfig()
            );
            // console.log('da- ', usrExs['data']);
            data.usr_exst = usrExs['data']['data'][0][0] ? usrExs['data']['data'][0][0] : '';
            // console.log(data);
            return data;
        } else {
            return data;
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
};

// export const authorizeData = async (jsVal) => {
//   try {
//     const { data } = await axios.post(uriSer + "/authsf", jsVal, config);

//     if (data["data"].access_token) {
//       const usrExs = await axios.post(
//         uriSer + "/fetch",
//         {
//           type: "fetch",
//           qry: "fetUsrExs",
//           firstVal: jsVal.usr,
//         },
//         config
//       );
//       // console.log("da- ", data["data"]);
//       data["data"].usr_exst = usrExs["data"]["data"][0].exst;
//       // console.log("us- ", usrExs["data"]["data"][0].exst);
//       return data;
//     } else {
//       return data;
//     }
//   } catch (error) {
//     console.log(error);
//   }
// };

export const insJsData = async (jsVal) => {
    try {
        const encReq = encryptAndCompress(jsVal, '');
        const { data } = await axios.post(uriSer + '/ins', { encReq }, getConfig());
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const updJsData = async (jsVal) => {
    try {
        const encReq = encryptAndCompress(jsVal, '');
        const { data } = await axios.post(uriSer + '/upd', { encReq }, getConfig());
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

// Simplified retry utility function with minimal logging
const retryWithBackoff = async (fn, maxRetries = 3, baseDelay = 1000) => {
    let lastError;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            const result = await fn();

            if (result.success) {
                if (attempt > 1) {
                    console.log(`✅ Application initialized successfully on attempt ${attempt}`);
                }
                return result;
            }

            // If result indicates failure, treat as error for retry logic
            throw new Error(result.error || 'Application initialization failed');
        } catch (error) {
            lastError = error;

            // Only log retries, not every attempt
            if (attempt > 1) {
                console.warn(`❌ Retry attempt ${attempt}/${maxRetries} failed:`, error.message);
            }

            // If this is the last attempt, don't wait
            if (attempt === maxRetries) {
                break;
            }

            // Shorter delays: 1s, 2s for just 3 attempts total
            const delay = baseDelay * attempt;

            // Wait before next attempt (no console spam)
            await new Promise((resolve) => setTimeout(resolve, delay));
        }
    }

    // If we get here, all retries failed
    throw lastError;
};

export const fetchClientConfig = async (userIdentifier = 'default') => {
    // Internal function that performs the actual API call
    const performInitialiseRequest = async () => {
        try {
            // Create a timestamp-based challenge for additional security
            const timestamp = Date.now();
            const challenge = `${userIdentifier}-${timestamp}`;

            // Use encrypted INIT_KEY from environment variables
            let initKey = null;
            if (process.env.REACT_APP_INIT_KEY_ENCRYPTED) {
                try {
                    // Decrypt the key using ROT13 + Base64 (matching backend logic)
                    const encryptedKey = process.env.REACT_APP_INIT_KEY_ENCRYPTED;
                    const decoded = atob(encryptedKey); // Base64 decode
                    // ROT13 decryption
                    initKey = decoded.replace(/[a-zA-Z]/g, function (c) {
                        return String.fromCharCode((c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26);
                    });
                } catch (decryptError) {
                    console.error('Failed to decrypt REACT_APP_INIT_KEY_ENCRYPTED:', decryptError);
                }
            } else {
                console.error('REACT_APP_INIT_KEY_ENCRYPTED not found in environment variables');
            }

            if (!initKey) {
                console.error('REACT_APP_INIT_KEY_ENCRYPTED not available or failed to decrypt');
                throw new Error('Application configuration error: Missing encrypted initialization key');
            }

            // Simple hash of challenge + key (in production, use proper HMAC)
            const crypto = require('crypto');
            const challengeHash = crypto
                .createHash('sha256')
                .update(challenge + initKey)
                .digest('hex');

            // Create payload similar to other API calls
            const payload = {
                user: userIdentifier,
                challenge: challenge,
                challengeHash: challengeHash,
                timestamp: timestamp,
                requestType: 'initialise',
            };

            // For initialise endpoint, use a simpler encryption that doesn't depend on secure config
            // Use the init key directly for encryption instead of pbkdf2 with secure config
            const simpleKey = crypto.pbkdf2Sync(initKey, 'init-salt', 1000, 16, 'sha256');
            const cipher = crypto.createCipheriv('aes-128-cbc', simpleKey, Buffer.alloc(16, 0));
            let encrypted = cipher.update(JSON.stringify(payload), 'utf8', 'base64');
            encrypted += cipher.final('base64');

            // Minimal headers - no sensitive data exposed
            const configHeader = {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            };

            // Send encrypted payload with simpler encryption
            const { data } = await axios.post(uriSer + 'initialise', { encReq: encrypted }, configHeader);

            if (data.success === 1) {
                // Decrypt the received configuration using the same simple encryption
                // Cannot use decryptAndDeCompress as it depends on secure config we're trying to get!
                const crypto = require('crypto');
                const simpleKey = crypto.pbkdf2Sync(initKey, 'init-salt', 1000, 16, 'sha256');
                const decipher = crypto.createDecipheriv('aes-128-cbc', simpleKey, Buffer.alloc(16, 0));
                let decrypted = decipher.update(data.data, 'base64', 'utf8');
                decrypted += decipher.final('utf8');
                const configObj = JSON.parse(decrypted);

                // Validate timestamp to prevent replay attacks (within 5 minutes)
                const currentTime = Date.now();
                const configTime = configObj.timestamp;
                const timeDiff = currentTime - configTime;

                if (timeDiff > 5 * 60 * 1000) {
                    // 5 minutes in milliseconds
                    throw new Error('Configuration data is too old, possible replay attack');
                }

                // Store configuration securely in environment or state management
                // Remove sensitive fields before returning
                const { timestamp, requestId, ...clientConfig } = configObj;

                return {
                    success: true,
                    config: clientConfig,
                    requestId: requestId,
                };
            } else {
                throw new Error(data.message || 'Failed to initialise application');
            }
        } catch (error) {
            console.error('Error during application initialisation:', error);
            return {
                success: false,
                error: error.message || 'Failed to initialise application',
            };
        }
    };

    // Use simplified retry mechanism (3 attempts max, no UI notifications)
    try {
        return await retryWithBackoff(performInitialiseRequest, 3, 1000);
    } catch (error) {
        console.error('🚫 Application initialization failed after retries:', error.message);
        return {
            success: false,
            error: error.message || 'Failed to initialise application after multiple attempts',
        };
    }
};
